import styled from 'styled-components';
import { Icon } from 'components/shared';


const StyledButtonBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
  align-items: flex-start;
  position: absolute;
  background-color: transparent;
  padding: 1.5rem; 
  width: 14rem;
  top: 0px;
  right: 20px;
  @media (max-width: 1024px) {
    position: relative;
    top: 0;
    right: 0;
  }
`;
const StyledIcon = styled(Icon)`
  margin-right: 0.5rem;
  color: var(--color-secondary-text);
`;

const UploadAndDownoadButtons = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-size: 0.875rem;        
  font-weight: 500;              
  transition: all 0.2s;
  color: var(--color-secondary-text);
  border: 1px solid #e5e7eb;     
  background: #fff;             
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);    
  gap: 0.375rem;                 
  padding-left: 0.75rem;        
  padding-right: 0.75rem;
  height: 2rem;                
  cursor: pointer;
  outline: none;

  &:hover {
    background: #f1f5f9;           
    color: #1e293b;     
  }
  &:focus-visible {
    border-color: #6366f1;        
    box-shadow: 0 0 0 3px rgba(99,102,241,0.5); 
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

const PopoverWrapper = styled.div`
  position: absolute;
  min-width: max-content;
  z-index: 50;
  top: 100px;
  right: 0;
`;

const PopoverContent = styled.div`
  z-index: 50;
  border-radius: 0.375rem;
  border: 1px solid #e5e7eb;
  background: #fff;
  padding: 1rem;
  color: var(--color-secondary-text);
  box-shadow: 0 4px 24px 0 rgba(0,0,0,0.08), 0 1.5px 4px 0 rgba(0,0,0,0.03);
  outline: none;
  width: 20rem;
`;

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Title = styled.h4`
  font-weight: 500;
  margin: 0;
`;

const Description = styled.p`
  font-size: 0.875rem;
  color: var(--color-secondary-text);
  margin: 0;
`;

const DownloadButton = styled.button`
  font-family: 'Montserrat', sans-serif;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  font-size: 0.875rem; 
  font-weight: 700; 
  outline: none;
  height: 2.25rem;
  padding: 0.5rem 1rem; 
  width: 100%; 
  background-color: #395905; 
  color: #fff;  
  cursor: pointer; 
  border: none;

  &:hover {
    background-color: #052959;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
const StyledScheduleImport = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
`;

const StyledScheduleImportBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const StyledScheduleImportForm = styled.div`
  position: relative;
`;

export {
  StyledButtonBlock,
  UploadAndDownoadButtons,
  PopoverWrapper,
  PopoverContent,
  FlexCol,
  Title,
  Description,
  DownloadButton,
  Wrapper,
  StyledIcon,
  StyledScheduleImport,
  StyledScheduleImportBlock,
  StyledScheduleImportForm,
};
